import React from "react";
import {
  TouchableOpacity,
  View,
  Text,
  StyleSheet,
  GestureResponderEvent,
} from "react-native";

import Modal from "./base/Modal";

import { Ionicons as Icon } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/native";
import StyledButton from "../StyledButton";
import FontStyles from "../../constants/FontStyle";
import Colors from "../../constants/Colors";

interface IProps {
  isOpen: boolean;
  toggleModal: VoidFunction;
  message: string;
}

const OrderConfirmModal: React.FC<IProps> = ({
  isOpen,
  toggleModal,
  message,
}) => {
  const navigation = useNavigation();
  const clickAreaRef = React.useRef<any>();

  const gotoProduct = () => {
    toggleModal();
    navigation.navigate("HomeTab");
  };
  const handleClickOutside = (e: GestureResponderEvent) => {
    e.persist();
    if (clickAreaRef.current) {
      if (e.target === clickAreaRef?.current?._nativeTag) {
        toggleModal();
      }
    }
  };

  return (
    <Modal
      presentationStyle="overFullScreen"
      animationType="slide"
      transparent={true}
      visible={isOpen}
      onRequestClose={() => {
        toggleModal();
      }}
    >
      <View
        ref={clickAreaRef}
        onStartShouldSetResponder={(e) => {
          handleClickOutside(e);
          return true;
        }}
        style={styles.overlay}
      >
        <View style={styles.container}>
          <TouchableOpacity
            style={styles.closeButton}
            onPress={() => {
              toggleModal();
            }}
          >
            <Text style={styles.closeButtonText}>Close</Text>
            <Icon name="md-close" size={24} color="#FFFFFF" />
          </TouchableOpacity>

          <View style={[styles.card, styles.successCard]}>
            <Icon
              name="ios-checkmark-circle"
              size={57.75}
              color="#00A879"
              style={{ margin: 9.63 }}
            />
            <Text
              style={[
                styles.cardBody,
                {
                  // height: 60,
                  width: 238,
                  ...FontStyles.dark,
                  ...FontStyles.normal,
                  ...FontStyles.size14,
                  ...FontStyles.lh20,
                  textAlign: "center",
                },
              ]}
            >
              {message}
            </Text>

            <StyledButton
              label="Continue Shopping"
              style={{ marginTop: 28 }}
              action={gotoProduct}
            />
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default OrderConfirmModal;

const styles = StyleSheet.create({
  overlay: {
    backgroundColor: "rgba(0,0,0,0.6)",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
  container: {
    width: "100%",
    paddingHorizontal: 16,
    justifyContent: "center",
  },
  closeButton: {
    flexDirection: "row",
    alignSelf: "flex-end",
    marginBottom: 8,
    marginRight: 16,
  },
  closeButtonText: {
    color: Colors.whiteColor,
    ...FontStyles.size14,
    ...FontStyles.lh16,
    ...FontStyles.bold,
    alignSelf: "center",
    marginRight: 8,
  },
  card: {
    borderTopLeftRadius: 25,
    borderTopRightRadius: 25,
    backgroundColor: "#FFFFFF",
    paddingHorizontal: 20,
    paddingTop: 24,
    paddingBottom: 16,
  },
  successCard: {
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
    backgroundColor: "#FFFFFF",
    marginHorizontal: 16,
    alignItems: "center",
  },
  cardBody: {
    width: 288,
    ...FontStyles.dark,
    ...FontStyles.size14,
    ...FontStyles.lh20,
    ...FontStyles.normal,
  },
});
